<template>
  <vx-card id="card-vessel-report-confirmor" title="確認者">
    <div
      class="vessel-report-confirmor-list"
      v-for="(confirmor, index) in confirmorList"
      :key="index"
    >
      <report-confirmor-list-item
        :confirmor="confirmor"
      ></report-confirmor-list-item>
    </div>
  </vx-card>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";
import ReportConfirmorListItem from "./ReportConfirmorListItem";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("vesselReportView");

export default {
  name: "VesselReportConfirmor",
  components: {
    ReportConfirmorListItem
  },
  computed: {
    ...mapState({
      confirmorList: state => state.confirmorList
    })
  },
  methods: {
    getAvatarText(name) {
      return name.charAt(0);
    },
    getAvatar(pictures) {
      if (pictures.length !== 0) {
        storage
          .child(pictures[0].thumbnail_path)
          .getDownloadURL()
          .then(response => {
            return response;
          });
      }
    },
    chipColor(value) {
      return value !== null ? "success" : "danger";
    },
    status(value) {
      return value !== null ? "確認済" : "未確認";
    }
  }
};
</script>

<style lang="scss" scoped>
.confirmor-status-chip {
  border-radius: 5px;
}
</style>
